module.exports = __webpack_public_path__ + "media/images/guidelines/video_share@3x-ead4d14508ab59625a3d9cabe15af9f1.png";